<template>
  <div class="megatabs__panel-left">
    <panel-section>
      <div class="panel-section__info panel-section__info--cool">
        <img
          class="panel-section__fridge-overlay"
          src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/coolzone.png"
          alt="">
        <header class="panel-section__header">
          <p class="panel-section__tab-name">
            CoolManagement System
          </p>
          <h3 class="panel-section__title">
            CoolZone
          </h3>
          <p class="panel-section__subtitle">
            {{ pl ? 'Komora chłodziarki' : 'Fridge compartment' }}
          </p>
        </header>
        <p class="panel-section__description">
          {{
            pl
            ? 'Znajdź najbardziej odpowiednie miejsce do przechowywania produktów spożywczych w ramach chłodziarki.'
            : 'Find the best place for storing food products in a fridge'
          }}
        </p>
      </div>
      <div class="feature-box feature-box--blue">
        <header class="feature-box__header">
          <div class="feature-box__icon">
            <img
              src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/ikony/coolbalance.svg"
              alt="CoolBalance" />
          </div>
          <h4 class="feature-box__title feature-box__title--red">
            CoolBalance
          </h4>
        </header>
        <template v-if="pl">
          <p class="feature-box__description">
            Otwieraj i zamykaj lodówkę utrzymując stabilny poziom temperatury wewnątrz! Specjalna metalowa płytka na tylnej ścianie chłodziarki sprawia, że jest ona mniej podatna na wahania temperatury spowodowane otwieraniem drzwi.
          </p>
          <p class="feature-box__description">
            Takie rozwiązanie to nie tylko lepsza dbałość o świeżość produktów dzięki stabilnej temperaturze, ale także oszczędność energii i bez wątpienia bardzo estetyczne wykończenie wnętrza twojej lodówki.
          </p>
        </template>
        <template v-else>
          <p class="feature-box__description">
            Open and close the fridge, and the temperature inside stays the same! A dedicated metal panel on the back wall inside the fridge makes the internal temperature less prone to fluctuate when the fridge doors are opened and closed.
          </p>
          <p class="feature-box__description">
            This helps keep the food fresh for longer, maintaining a stable temperature while improving energy efficiency and giving the interior a great look.
          </p>
        </template>
        <left-side-video-handler  v-if="pl" :vid_id="'kxwdBVk1Sfg'"></left-side-video-handler>
      </div>

      <img
        class="panel-section__separator-img"
        src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/coolzone_foto_full.jpg"
        alt="Wnętrze komory chłodziarki">

      <div class="feature-box feature-box--blue">
        <h4 class="feature-box__title">
          {{ pl ? 'Jakie produkty przechowywać?' : 'What products to store?' }}
        </h4>
        <ul class="feature-box__list">
          <li class="feature-box__item">
            {{ pl ? 'Najwyższa półka:' : 'The shelf:' }}
            <strong>
              {{ pl ? 'jogurty, kefiry, nabiał, ciasta, desery' : 'yogurt, kephir, dairy, cakes, desserts' }}
            </strong>
          </li>
          <li class="feature-box__item">
            {{ pl ? 'Druga półka:' : 'Second shelf:' }}
            <strong>
              {{ pl ? 'sery żółte, pleśniowe, dojrzewające, wędliny, szynki, kiełbasy' : 'hard cheese, blue cheese, ripening cheese, cold cuts, ham, sausages' }}
            </strong>
          </li>
          <li class="feature-box__item">
            {{ pl ? 'Trzecia półka:' : 'Third shelf:' }}
            <strong>
              {{ pl ? 'dania gotowe: zupy, sałatki, obiady, przekąski' : 'convenience food: soups, salads, dinners, snacks ' }}
            </strong>
          </li>
          <li class="feature-box__item">
            {{ pl ? 'Górna szuflada:' : 'Top drawer:' }}
            <strong>
              {{ pl ? 'warzywa i owoce głównie zielone' : 'fruits and vegetables, mainly green' }}
            </strong>
          </li>
        </ul>
      </div>
    </panel-section>

    <panel-section>
      <div class="panel-section__info panel-section__info--adapt">
        <img
          class="panel-section__fridge-overlay"
          src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/adaptzone.png"
          alt="">
        <header class="panel-section__header">
          <p class="panel-section__tab-name">
            CoolManagement System
          </p>
          <h3 class="panel-section__title">
            AdaptZone
          </h3>
          <p class="panel-section__subtitle">
            {{ pl ? 'Szuflada' : 'Drawer' }}
          </p>
        </header>
        <p class="panel-section__description">
          {{ pl ? 'Przechowuj w szufladzie AdaptZone najbardziej wymagające produkty.' : 'Store the most sensitive food products in the AdaptZone drawer' }}
        </p>
      </div>      
      <div class="feature-box feature-box--green">
        <header class="feature-box__header">
          <div class="feature-box__icon">
            <img
              src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/ikony/adaptzone.svg"
              alt="AdaptZone" />
          </div>
          <h4 class="feature-box__title feature-box__title--red">
            AdaptZone
          </h4>
        </header>
        <p class="feature-box__description">
          {{
            pl
            ? 'AdaptZone to szuflada we wnętrzu chłodziarki z możliwością odrębnej regulacji temperatury za pomocą specjalnego przycisku na panelu sterowania. Jest to idealne miejsce dla produktów, które wymagają szczególnych warunków przechowywania. Dzięki wtłoczeniu poprzez specjalny otwór odpowiedniej ilości chłodnego powietrza oraz możliwości ustawienia konkretnej temperatury w zakresie od -3 do 3°C przechowywane w szufladzie produkty dłużej zachowują swój smak, zapach i wartości odżywcze.'
            : 'AdaptZone is a fridge drawer where the temperature can be adjusted separately from -3 to 3°C by means of a special button on the control panel. It is an ideal place for products which require special storage conditions: raw meat and fish, some fruits and vegetables , desserts and coffee grains.'
          }}
        </p>
      </div>
      <img
        class="panel-section__separator-img"
        src="http://dev.vmrhost.net/tests/amica/pl.amica/20200729_dig-225_lodowki_tlumaczenie/theme/Modern/img/View/lodowki-do-zabudowy-2020/adaptzone_foto_full.png"
        alt="Szuflada AdaptZone">
      <div class="feature-box feature-box--green">
        <h4 class="feature-box__title">
          {{ pl ? 'Jakie produkty przechowywać?' : 'What products to store?' }}
        </h4>
        <ul class="feature-box__list">
          <li class="feature-box__item">
            <strong>
              {{ pl ? 'Świeże mięso, surowy drób, steki, produkty mięsne przed obróbką termiczną np. zrazy i rolady; ryby, owoce morza' : 'Raw meat, raw poultry, steaks, meat products before heat treatment, e.g. roulades; fish, seafood' }}
            </strong>
          </li>
          <li class="feature-box__item">
            <strong>
              {{ pl ? 'Warzywa typu brukselka, marchew, seler' : 'Vegetables like Brussels sprouts, carrots and celeriac' }}
            </strong>
          </li>
          <li class="feature-box__item">
            <strong>
              {{ pl ? 'Niektóre desery, galaretki' : 'Some desserts, jelly' }}
            </strong>
          </li>
          <li class="feature-box__item">
            <strong>
              {{ pl ? 'Ziarna kawy' : 'Coffee grains' }}
            </strong>
          </li>
        </ul>
      </div>
    </panel-section>

    <panel-section>
      <div class="panel-section__info panel-section__info--freeze">
        <img
          class="panel-section__fridge-overlay"
          src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/freezezone.png"
          alt="">
        <header class="panel-section__header">
          <p class="panel-section__tab-name">
            CoolManagement System
          </p>
          <h3 class="panel-section__title">
            FreezeZone
          </h3>
          <p class="panel-section__subtitle">
            {{ pl ? 'Szuflady zamrażarki' : 'Freezer drawers' }}
          </p>
        </header>
        <p class="panel-section__description">
          {{
            pl
            ? 'Znajdź optymalne miejsce na zapasy w szufladach zamrażarki.'
            : 'Find the most suitable storage place in the freezer’s drawers.'
          }}
        </p>
      </div>      
      <div class="feature-box feature-box--darkblue">
        <ul class="feature-box__list feature-box__list--nomt">
          <li class="feature-box__item">
            {{ pl ? 'Najlepsze efekty uzyskuje się przy obniżeniu temperatury poniżej -18&deg;C.' : 'The best results can be expected when the temperature drops below -18&deg;C.' }}
          </li>
          <li class="feature-box__item">
            {{ pl ? 'Mrożenie nie zmienia struktury białek, tłuszczów, nie powoduje utraty witamin. Mrożone produkty nie tracą swoich wartości smakowych.' : 'Freezing does not affect the structure of proteins or fats,  nor does it kill vitamins. Food products do not lose their flavour in the process of freezing.' }}
          </li>
          <li class="feature-box__item">
            {{ pl ? 'Poprzez zamrażanie produktów można wydłużyć okres przechowywania aż do 12 miesięcy.' : 'Frozen food products can be stored for up to 12 months.' }}
          </li>
          <li class="feature-box__item">
            {{ pl ? 'Mrożenie można stosować zarówno do produktów mącznych jak i mięs, wędlin oraz ryb.' : 'Flour products, meat, cold cuts and fish can all be frozen.' }}
          </li>
        </ul>
      </div>
      <img
        class="panel-section__separator-img"
        src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/freezezone_foto_full.jpg"
        alt="Wnętrze zamrażarki">
      <div class="feature-box feature-box--darkblue">
        <h4 class="feature-box__title">
          {{ pl ? 'Jakie produkty przechowywać?' : 'What products to store?' }}
        </h4>
        <ul class="feature-box__list">
          <li class="feature-box__item">
            {{ pl ? 'Pierwsza szuflada:' : 'First drawer:' }}
            <strong>
              {{ pl ? 'Mrożonki z warzyw i owoców oraz lody' : 'Frozen fruits and vegetables, ice-cream' }}
            </strong>
          </li>
          <li class="feature-box__item">
            {{ pl ? 'Druga szuflada:' : 'Second drawer:' }}
            <strong>
              {{ pl ? 'Pierogi, frytki, pieczywo, pizza' : 'Pierogi, French fries, bread, pizza' }}
            </strong>
          </li>
          <li class="feature-box__item">
            {{ pl ? 'Trzecia szuflada:' : 'Third drawer:' }}
            <strong>
              {{ pl ? 'Mięso i ryby' : 'Meat and fish' }}
            </strong>          
          </li>
        </ul>
      </div>
    </panel-section>

    <panel-section class="panel-section--nobg">
      <img
        class="panel-section__header-img"
        src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/lodowka-nofrost.png"
        alt="Total NoFrost">
      <header class="panel-section__header">
        <div class="panel-section__icon">          
          <img
            src="https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/ico-total-nofrost.svg"
            alt="Total NoFrost">
        </div>
        <h3 class="panel-section__title">
          Total NoFrost
        </h3>
      </header>
      <template v-if="pl">
        <p class="panel-section__description">
          Lubisz rozmrażać lodówkę? Jeśli nie, już nigdy nie będziesz musiał tego robić! Technologia Total NoFrost zapewnia stałą kontrolę poziomu wilgotności zarówno w chłodziarce jak i zamrażarce, co oznacza brak szronu w środku. A brak szronu to brak potrzeby rozmrażania!
        </p>
        <p class="panel-section__description">
          Total NoFrost to też większa higiena i dłuższa świeżość Twoich produktów, bo stała temperatura w całej lodówce ogranicza do minimum ryzyko rozwoju bakterii. Nie musisz nic robić, a wygodnie oszczędzasz!
        </p>
      </template>
      <p class="panel-section__description" v-else>
        Who enjoys defrosting their fridge? From now on you never have to again! The Total NoFrost technology constantly monitors the humidity level in the fridge and freezer as well, ensuring no frost inside. No frost means more than no defrosting, it also provides better hygiene and longer product freshness, as the stable temperature in the entire refrigerator minimizes the risk of bacteria. No need to do anything, just save time in comfort!
      </p>
    </panel-section>
  </div>
</template>

<script>
import LeftSideVideoHandler from "./LeftSideVideoHandler";
import PanelSection from "./PanelMobileSection";

export default {
  props: ["component_data"],
  components: {
    LeftSideVideoHandler,
    PanelSection,
  }
};
</script>

<style lang="scss" scoped>
</style>